export default "__VITE_ASSET__BK7OJqD8__"